'use client'

import { Styled404 } from './page.styles'
import { Stack, Typography } from '@mui/material'
import { Button } from '@biolumina/ui/components/button/button'

export default function Page404() {
  return (
    <Styled404
      hero={
        <Stack className="not-found">
          <Stack direction="column" className="message-wrapper">
            <Typography className="message">404 Error</Typography>
            <Typography variant="h6" alignSelf="center">
              Page not found
            </Typography>
            <Button
              data-tracking="top-utility-nav-item"
              fontWeight={700}
              sx={{ fontSize: '18px' }}
              href="/"
              className="blue"
            >
              Return to the homepage
            </Button>
          </Stack>
        </Stack>
      }
    />
  )
}
